import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {FlatpickrDefaultsInterface} from 'angularx-flatpickr';
import {IAppliedFiltersUpdater, IAppliedFiltersUpdaterToken} from '../../../applied-filters-updater';
import {AbstractFilterComponent} from '../../abstract-filter.component';
import {AdvancedFilterOperatorEnum, AdvanceFilterParamType} from '../../advance-filter';

@Component({
    selector: 'app-datepicker-filter',
    templateUrl: './datepicker-filter.component.html',
    styleUrl: './datepicker-filter.component.scss'
})
export class DatepickerFilterComponent extends AbstractFilterComponent implements OnInit{
    fromDate: string = null;
    toDate: string = null;

    constructor(
        formBuilder:FormBuilder,
        @Inject(IAppliedFiltersUpdaterToken) filterUpdater: IAppliedFiltersUpdater<AdvanceFilterParamType>) {
        super(formBuilder,filterUpdater);
    }

    ngOnInit(): void {
        this.setStartAndEndDateByValue(this._value);
        this.filterForm.controls['value'].setValue(this.getValue());
        this.filterForm.controls['operator'].setValue( this.matchOperator());
    }

    flatpickrConfig: FlatpickrDefaultsInterface = {
        altFormat: 'Y-m-d',
        dateFormat: 'Y-m-d',
        altInput: true,
        static:true,
    }

    fromDateChanged($event: InputEvent) {
        this.fromDate = (<HTMLInputElement>$event?.target)?.value;
        this.filterForm.controls['value'].setValue(this.getValue());
        this.filterForm.controls['operator'].setValue( this.matchOperator());

    }

    toDateChanged($event: InputEvent) {
        this.toDate = (<HTMLInputElement>$event?.target)?.value;
        this.filterForm.controls['value'].setValue(this.getValue());
        this.filterForm.controls['operator'].setValue( this.matchOperator());
    }

    override  setUpForm(): void {
        this.filterForm = this._formBuilder.group({
            value: ['', [Validators.required]],
            operator: ['', [Validators.required]],
        })
    }

    private setStartAndEndDateByValue(value){
        if(value){
            if(value instanceof Array){
                if(value.length === 1){
                    this.fromDate = value[0];
                } else if(value.length === 2){
                    this.fromDate = value[0];
                    this.toDate = value[1];
                }else{
                    this.fromDate = null;
                    this.toDate = null;
                }
            }else{
                if(this.operator === AdvancedFilterOperatorEnum.gte ||  this.operator === AdvancedFilterOperatorEnum.gt){
                    this.fromDate = value;
                    this.toDate = null;
                }

                if(this.operator === AdvancedFilterOperatorEnum.lte ||  this.operator === AdvancedFilterOperatorEnum.lt){
                    this.fromDate = null;
                    this.toDate = value;
                }
            }
        }else{
            this.fromDate = null;
            this.toDate = null;
            this.operator =null;
        }
    }

    private matchOperator(): AdvancedFilterOperatorEnum {
        if (this.isDateDefined(this.fromDate ) && this.isDateDefined(this.toDate )) {
            return AdvancedFilterOperatorEnum.between;
        }

        if (this.isDateDefined(this.fromDate ) && !this.isDateDefined(this.toDate )) {
            return AdvancedFilterOperatorEnum.gte
        }

        if (this.isDateDefined(this.toDate) && !this.isDateDefined( this.fromDate )) {
            return AdvancedFilterOperatorEnum.lte;
        }

        return null;
    }

    private getValue() {
        if ( this.isDateDefined(this.fromDate) && this.isDateDefined(this.toDate)) {
            return [this.fromDate, this.toDate];
        }

        if (this.isDateDefined(this.fromDate ) && !this.isDateDefined(this.toDate)) {
            return this.fromDate;
        }

        if (this.isDateDefined(this.toDate ) && !this.isDateDefined(this.fromDate)) {
            return this.toDate;
        }
        return null;
    }

    private isDateDefined(date):boolean{
        return !!date
    }
}
